import React, { useEffect, useContext, useState } from 'react';

import { LoginContext } from '../../hooks/context/LoginContext';

import Menusup from '../../componentes/menus/menusup/Menusup';
import Sidebar from '../../componentes/menus/sidebar/Sidebar';
import Formulario from '../../componentes/formulario/Formulario';
import FormRow from '../../componentes/formulario/FormRow';
import FormInput from '../../componentes/formulario/FormInput';
import Footer from '../../componentes/footer/Footer';
import Section from '../../componentes/ui/Section';
import MiDataTable from '../../componentes/ui/MiDataTable';
import { Alert } from '../../componentes/ui/Alert';
import MiSelect from '../../componentes/formulario/MiSelect';
import PermissionRefused from '../../componentes/ui/PermissionRefused';
import LoadingPage from '../../componentes/ui/LoadingPage';

import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Spinner from 'react-bootstrap/Spinner';

import useLogicForm from '../../hooks/useLogicForm';

import Cookies from 'universal-cookie';

import { getTitle, getDecodedCookie } from '../../helpers/helperApp';

import { Fragment } from 'react';

function ClaUni(props){

    const cookies = new Cookies();

    // ***** Context *****
    const { validateSesion, socket, confApp, saveConfApp, getConfApp } = useContext(LoginContext);    

    // ***** State para la configuración de la pantalla *****
    const [ confPantalla, saveConfPantalla ] = useState(confApp)
    const [ loadedConf, saveLoadedConf ] = useState(false);
    const [ tieneNivel, saveTieneNivel ] = useState(true);
    const [ estadoFormPrin, saveEstadoFormPrin ] = useState("");
    const [ estadoFormHijo, saveEstadoFormHijo ] = useState("");

    // ***** Custom Hook - Lógica de los formularios *****
    const { registrosPrin, saveRegistrosPrin, formularioPrin, saveFormularioPrin, saveFormularioHijo , handleInputForm, handleLastReg, handleEditRegPrin, loadingTable, saveLoadingTable, loadReg, regIniciales, handleDeleteItemPrin, handleSubmitPrin, resetFormPrin, handleSelectFormPrin } = useLogicForm();

    useEffect( () => {        
        
        // ***** Validamos que el usuario esté logueado sino lo enviamos al login*****
        validateSesion(props)
            .then( (respuesta) => {
                if( confPantalla === undefined ){
                    return getConfApp();
                }else{  
                    document.title = getTitle(confPantalla.config.trad, confPantalla.clauni.title);                                     
                    if( respuesta == 1 ){ 
                        saveTieneNivel(true);                            
                        saveEstadoFormPrin(confPantalla.clauni.padre.estadoform);
                        saveEstadoFormHijo(confPantalla.clauni.hijo.estadoform); 
                        // ***** Carga inicial de registros *****
                        if( registrosPrin ){
                            if( registrosPrin.length === 0 ){
                                saveLoadingTable(true);
                                regIniciales(saveRegistrosPrin, confPantalla.clauni.padre.urls);
                                saveFormularioPrin(confPantalla.clauni.padre.modelform);
                                saveFormularioHijo(confPantalla.clauni.hijo.modelform);     
                            }
                        }  
                        // Seleccionar el id que nos llega como parámetro por la url
                        if( props.location.state ){
                            if( "idPrin" in props.location.state || "idHijo" in props.location.state ){
                                handleLastReg(props.location.state.idPrin, props.location.state.idHijo, confPantalla.clauni.padre.urls, confPantalla.clauni.hijo.urls, confPantalla.clauni.padre.tabla, props.location.state.estadoFormPrin, saveEstadoFormPrin, saveEstadoFormHijo);     
                            }                        
                        }                      
                    }
                    else if( respuesta == 0 ){
                        saveTieneNivel(false);
                    }                    
                    saveLoadedConf(true);        
                }
            })
            .then( (respuesta) => {
                if( respuesta !== undefined  ){
                    saveConfPantalla(respuesta.msg);
                    saveConfApp(respuesta.msg);             
                }
            })          

        // Liberamos todos los registros al salir de la pantalla
        return () =>{
            if( socket != null ){
                socket.emit("salirPantalla", { "idusu": getDecodedCookie('id'), "tabla": "undefined" })
            }
                document.querySelector("body").classList.remove("sidebar-open");
        } 

    },[confPantalla])
 

    return(
        <div className="App wrapper">
            <div>
                {   loadReg ?
                    <div className="alertFullWhite">
                        <Spinner animation="border" />
                    </div> 
                    :
                    null
                }
                {
                    !loadReg ?
                        <Alert fondo={true} />
                    :
                        <Alert />
                }                                
            </div>    
        {
            confPantalla !== undefined
            ?
                <Fragment>
                    <Menusup 
                        props = { props }
                    />
                    <Sidebar 
                        props = { props }
                    />
                </Fragment>
            :
            null
        } 
        <div className="content-wrapper">
            <div className="content-header">
            </div>
            <section className="content">
                {
                    !tieneNivel 
                    ?
                        <PermissionRefused
                            traduction={confPantalla.config.trad.components.permissionrefused} 
                        />
                    :
                    <Fragment>
                    {
                        loadedConf === true && confPantalla !== undefined
                        ?
                        <Section titulo={ confPantalla.clauni.section.titulo } icono={ confPantalla.clauni.section.icono } col={ confPantalla.clauni.section.col } idPrin={ formularioPrin.id } wiki={ confPantalla.clauni.section.wiki } >
                            <Formulario 
                                        estadoForm= { estadoFormPrin }
                                        loading=    { loadReg ? true : false }
                                        btnNew={ confPantalla.clauni.padre.btnform.new }
                                        btnSave={ confPantalla.clauni.padre.btnform.save }
                                        btnSaveAndNew={ confPantalla.clauni.padre.btnform.saveandnew }
                                        btnDelete={ confPantalla.clauni.padre.btnform.delete }
                                        btnClone={ confPantalla.clauni.padre.btnform.clone }
                                        handleSubmit = { e => handleSubmitPrin(e, confPantalla.clauni.padre.urls, confPantalla.clauni.padre.modelform, confPantalla.clauni.padre.tabla, confPantalla.clauni.hijo.modelform, confPantalla.clauni.title) } 
                                        formulario = { formularioPrin } 
                                        resetForm = { e => resetFormPrin(confPantalla.clauni.padre.modelform, true, confPantalla.clauni.padre.tabla) } 
                                        handleDeleteItem = { e => handleDeleteItemPrin(undefined, confPantalla.clauni.padre.urls, confPantalla.clauni.padre.modelform, confPantalla.clauni.padre.tabla, confPantalla.clauni.title) }
                            >         
                            <h4>{ formularioPrin.ruta }</h4>   
                                <FormRow clases="" >
                                    <MiSelect  
                                        estadoForm=  { estadoFormPrin }
                                        val=         { formularioPrin.pad  }   
                                        loading=     { loadReg ? true : false }
                                        id=          { confPantalla.clauni.padre.controles.pad.id }    
                                        name=        { confPantalla.clauni.padre.controles.pad.name }   
                                        label=       { confPantalla.clauni.padre.controles.pad.label }    
                                        placeholder= { confPantalla.clauni.padre.controles.pad.placeholder }
                                        col=         { confPantalla.clauni.padre.controles.pad.col } 
                                        isClearable= { confPantalla.clauni.padre.controles.pad.isclearable }
                                        isSearchable={ confPantalla.clauni.padre.controles.pad.issearchable }
                                        dataType=    { confPantalla.clauni.padre.controles.pad.datatype }
                                        data=        { confPantalla.clauni.padre.controles.pad.data }
                                        required=    { confPantalla.clauni.padre.controles.pad.required } 
                                        disabled=    { confPantalla.clauni.padre.controles.pad.disabled }
                                        readOnly =   { confPantalla.clauni.padre.controles.pad.readonly }
                                        disablethisid={confPantalla.clauni.padre.controles.pad.disablethisid}
                                        formulario = { formularioPrin } 
                                        change=      { handleSelectFormPrin }                                                    
                                    />                                    
                                    <FormInput                                                        
                                        estadoForm= { estadoFormPrin }
                                        value=      { formularioPrin.nom }
                                        loading=    { loadReg ? true : false }
                                        id=         { confPantalla.clauni.padre.controles.nom.id }   
                                        type=       { confPantalla.clauni.padre.controles.nom.type }  
                                        name=       { confPantalla.clauni.padre.controles.nom.name }   
                                        label=      { confPantalla.clauni.padre.controles.nom.label }                                                       
                                        placeholder={ confPantalla.clauni.padre.controles.nom.placeholder }    
                                        col=        { confPantalla.clauni.padre.controles.nom.col } 
                                        required=   { confPantalla.clauni.padre.controles.nom.required }
                                        readonly=   { confPantalla.clauni.padre.controles.nom.readonly }                                                
                                        disabled=   { confPantalla.clauni.padre.controles.nom.disabled }
                                        change=     { e => handleInputForm(e, formularioPrin, saveFormularioPrin) }
                                        onBlur=     {null} 
                                    /> 
                                </FormRow>                            
                            </Formulario>
                            <MiDataTable
                                formulario={formularioPrin} 
                                estadoForm= { estadoFormPrin }
                                id={"clauni"}
                                columnas={confPantalla.clauni.padre.datatable.columns}
                                data={registrosPrin}
                                buttons={confPantalla.clauni.padre.datatable.buttons}
                                ordering={confPantalla.clauni.padre.datatable.ordering}
                                order={confPantalla.clauni.padre.datatable.order}
                                searching={confPantalla.clauni.padre.datatable.searching}
                                paging={confPantalla.clauni.padre.datatable.paging}
                                select={confPantalla.clauni.padre.datatable.select}
                                pagelength={confPantalla.clauni.padre.datatable.pagelength}
                                handleEditReg= { e => handleEditRegPrin(e, confPantalla.clauni.padre.urls, confPantalla.clauni.hijo.urls, confPantalla.clauni.padreshijos, confPantalla.clauni.hijo.modelform, confPantalla.clauni.padre.tabla) }
                                handleDeleteItem={ e => handleDeleteItemPrin(e, confPantalla.clauni.padre.urls, confPantalla.clauni.padre.modelform, confPantalla.clauni.padre.tabla, confPantalla.clauni.title) }                                
                                saveLoadingTable={ saveLoadingTable }
                                loadingTable={loadingTable}
                                columnactions={confPantalla.clauni.padre.datatable.columnactions.title}
                                traduction={confPantalla.config.trad.components.datatable}
                            />                                                                                                             
                            </Section>
                        :
                            <LoadingPage />
                        }
                    </Fragment>
                }
                
            </section>
        </div>
        <Footer />        
        </div>

    );

}
export default ClaUni